export const BASE_URL = '/api_web/tags';
